import type { ClassValue } from 'clsx';

import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Custom tailwind-merge instance that knows about our design system's
 * typography utilities (e.g. `text-heading-1`, `text-body`, etc.).
 *
 * By default, tailwind-merge treats any `text-*` class as a text color utility.
 * That means our custom font-size classes (like `text-heading-1`) would be
 * considered conflicting with `text-primary` or `text-foreground` and get
 * stripped out when merging.
 *
 * @see https://stackoverflow.com/a/76376770
 */
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'title1',
            'title1desktop',
            'title2',
            'title2desktop',
            'title3',
            'title3desktop',
            'title4',
            'title4desktop',
            'title5',
            'title5desktop',
            'title6',
            'title6desktop',
            'title7',
            'title7desktop',
            'headline1',
            'headline1desktop',
            'headline2',
            'headline2desktop',
            'headline3',
            'headline3desktop',
            'subtitle1',
            'subtitle1desktop',
            'subtitle2',
            'subtitle2desktop',
            'subtitle3',
            'subtitle3desktop',
            'paragraph',
            'paragraphdesktop',
            'paragraphlarge',
            'paragraphlargedesktop',
            'helper',
            'helperdesktop',
            'caption',
            'caption-desktop',
          ],
        },
      ],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => customTwMerge(clsx(inputs));
